// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bankId: __t.u64().primaryKey().name("bank_id"),
  kind: __t.string(),
  cityId: __t.u64().name("city_id"),
  name: __t.string(),
  status: __t.string(),
  charteredBy: __t.identity().name("chartered_by"),
  baseBps: __t.u32().name("base_bps"),
  reserveRatioBps: __t.u32().name("reserve_ratio_bps"),
  reserveFactorBps: __t.u32().name("reserve_factor_bps"),
  supplyIndex: __t.f64().name("supply_index"),
  scaledDeposits: __t.f64().name("scaled_deposits"),
  savingsBps: __t.f64().name("savings_bps"),
  utilization: __t.f64(),
  loansOutstanding: __t.f64().name("loans_outstanding"),
  depositsTotal: __t.f64().name("deposits_total"),
  vaultCash: __t.f64().name("vault_cash"),
  equity: __t.f64(),
  avgLoanBps: __t.f64().name("avg_loan_bps"),
  writtenOff: __t.i64().name("written_off"),
  interestEarned: __t.f64().name("interest_earned"),
  capitalFloor: __t.i64().name("capital_floor"),
  owesReserve: __t.f64().name("owes_reserve"),
  lastAccrualAt: __t.timestamp().name("last_accrual_at"),
  lastWeeklyAt: __t.timestamp().name("last_weekly_at"),
  createdAt: __t.timestamp().name("created_at"),
});
